import CockpitNotificationModel from '../../generated/types/model/resource/CockpitNotificationModel';

export default class CockpitNotificationViewModel extends CockpitNotificationModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
